import React from "react";
import { Container, Box, IconButton, Grid } from "@mui/material";
import FacebookIcon from "@mui/icons-material/Facebook";
import InstagramIcon from "@mui/icons-material/Instagram";
import LinkedInIcon from "@mui/icons-material/LinkedIn";
import logo from "../../Image/Logo.png"
import EmailIcon from '@mui/icons-material/Email';
import LocationOnIcon from '@mui/icons-material/LocationOn';
import '../../css/Navbar/Navbar.css';
import { FaPhoneAlt } from "react-icons/fa";



export const Footer = () => {
  return (
    <Box sx={{
      background: '#2C445F',
      color: "#fff",
      textAlign: "center",
      justifyContent: 'center',
      pt: 8,
      '@media (max-width:600px)': { pt: 5, }
    }}>
      <Container
        maxWidth="xl">
        <Box

        >
          <Grid container>
            <Grid size={{ xs: 12, sm: 4, md: 6 }}>
              {/* Logo */}
              <Box
                component="img"
                src={logo} // Cambia esto por la ruta correcta de tu logo
                alt="HOD | Maquinas Dispensadoras"
                title="HOD | Maquinas Dispensadoras"
                sx={{ height: 100, '@media (max-width:600px)': { py: 5, } }}
              />
            </Grid>
            <Grid size={{ xs: 12, sm: 8, md: 6 }} sx={{ display: 'flex', alignItems: 'flex-start', justifyContent: 'center', flexDirection: 'column', '@media (max-width:600px)': { alignItems: 'center' } }}>
              <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center',  '@media (max-width:500px)': { flexDirection: 'column', width: '100%', gap: 1 }, }}>
                <Grid container spacing={2} sx={{display:'flex', alignItems:'center', justifyContent:'center'}}>
                  <Grid size={{xs:12, sm:6, md:4}}>
                      <Box sx={{ display: "flex", alignItems: 'center', justifyContent: 'center' }}>
                  <IconButton
                    href="mailto:contacto@hod.com"
                    sx={iconButtonStyle}
                  >
                    <EmailIcon />
                  </IconButton>
                  <span className="textofooter">contacto@hod.com</span>
                </Box>
                  </Grid>
                  <Grid size={{xs:12, sm:6, md:4}}> 
                    <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
                  <IconButton
                    component="a"
                    href="tel:+56955217669"
                    sx={iconButtonStyle}
                  >
                    <FaPhoneAlt />
                  </IconButton>

                  <a href="tel:+56955217669" className="textofooter" style={{ textDecoration: "none", color: "inherit" }}>
                    +56 9 5521 7669
                  </a>
                </Box>
                  </Grid>
                  <Grid size={{xs:12, sm:6, md:4}}>
                      <Box sx={{ display: "flex", alignItems: 'center', justifyContent: 'center' }}>
                  <IconButton
                    href="https://maps.app.goo.gl/kSvkKZXLFu3FxGp57"
                    target="_blank"
                    rel="noopener noreferrer"
                    sx={iconButtonStyle}
                  >
                    <LocationOnIcon />
                  </IconButton>
                  <Box sx={{ display: "flex", flexDirection: 'column', alignItems: 'flex-start', textAlign:'justify' }}>
                    <span className="textofooter">San Ingnacio 030, Quilicura, Santiago</span>

                  </Box>
                </Box>
                  </Grid>

                </Grid>
              
               

              
              </Box>

            </Grid>
            <Grid size={12} sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', marginTop: '30px', width: '100%' }}>
              <Box sx={{
                display: 'flex', gap: 3, '@media (max-width:500px)': {
                  gap: 1,
                },
              }}>
                <IconButton
                  href="web.facebook.com/profile.php?id=61557919715539"
                  target="_blank"
                  rel="noopener"
                  sx={iconRedStyle}
                >
                  <FacebookIcon />
                </IconButton>
                <IconButton
                  href="https://www.instagram.com/hodvending"
                  target="_blank"
                  rel="noopener"
                  sx={iconRedStyle}
                >
                  <InstagramIcon />
                </IconButton>
                <IconButton
                  href="https://www.linkedin.com/company/hod-servicios-logísticos/"
                  target="_blank"
                  rel="noopener"
                  sx={iconRedStyle}
                >
                  <LinkedInIcon />
                </IconButton>

              </Box>
            </Grid>
          </Grid>



        </Box>
      </Container>
      <Box sx={{
        display: 'flex',
        justifyContent: 'center',
        gap: 8,
        mt: 4,
        '@media (max-width:500px)': {
          gap: 1,
        },
      }}>
        {['#FFFFFF', '#00A69E', '#6A3090', '#FFA457'].map((color, index) => (
          <Box
            key={index}
            sx={{
              width: '30%',
              height: 20,
              backgroundColor: color,

            }}
          />
        ))}
      </Box>
    </Box>
  );
};

const iconButtonStyle = {
  color: '#2C445F',
  with: '70px',
  marginRight: '10px',
  height: '35px',
  backgroundColor: '#fff',
  borderRadius: '20px',
  padding: '5px ',
  transition: 'all 0.3s ease',
  '@media (max-width:500px)': {
    marginRight: '5px',
    fontSize: 'rem',
    height: '30px',
  },
  '&:hover': {
    backgroundColor: '#2C445F',
    color: '#fff',
    transform: 'scale(1.05)',
  },
  '&:active': {
    transform: 'scale(0.98)',
    backgroundColor: '#083a8c',
  },
};

const iconRedStyle = {
  color: '#fff',
  with: '70px',
  marginRight: '10px',
  height: 'auto',
  backgroundColor: 'trasparent',
  border: '1px solid #ffff',
  borderRadius: '50px',
  transition: 'all 0.3s ease',
  '@media (max-width:500px)': { marginRight: '5px' },
  '&:hover': {
    backgroundColor: '#2C445F',
    color: '#fff',
    transform: 'scale(1.05)',
  },
  '&:active': {
    transform: 'scale(0.98)',
    backgroundColor: '#083a8c',
  },
};